<template>
  <span class="t-link">
    <a v-if="isExternalLink(link)" :href="link">
      <slot />
    </a>
    <router-link v-else :to="{ name: link }">
      <slot />
    </router-link>
  </span>
</template>

<script>
export default {
  name: "t-link",
  props: {
    link: String,
  },
  methods: {
    // (url: string): bool
    isExternalLink(link) {
      return link?.trim()?.startsWith("http")
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/ui-components/t-link/index.vue